export default "__VITE_ASSET__DxQL2Ata__"